import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import DisconnectServicesData from '../../../Models/Content/DisconnectServicesBlockData';
import DisconnectServiceMain from './DisconnectServiceMain/DisconnectServiceMain'
import './index.scss'

export default class DisconnectServices extends EpiComponent<DisconnectServicesData>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <DisconnectServiceMain context={this.getContext()} iContent={this.props.data}/>
        );
    }
}